<template>
  <v-container fluid>
    <v-col>
      <v-slide-y-transition mode="out-in">
        <v-row class="child-flex">
          <v-card>
            <v-card-text>
              <v-card-title>
                <v-col class="text-h4">{{ titleDesc }}</v-col>
                <v-spacer></v-spacer>
                <v-btn
                  :color="user.enabled ? 'orange' : 'black'"
                  :dark="!user.enabled"
                  @click.prevent="toggleUserEnabled"
                >
                  {{ enableDisableUserText }}
                </v-btn>
              </v-card-title>
              <v-form>
                <v-text-field
                  v-validate="'required'"
                  v-model="user.name"
                  :error-messages="errors.collect('name')"
                  label="Name"
                  data-vv-name="name"
                  required
                />
                <v-text-field
                  v-validate="'required|email'"
                  v-model="user.email"
                  :error-messages="errors.collect('email')"
                  type="email"
                  label="Email"
                  data-vv-name="email"
                  required
                />
                <v-text-field
                  v-model="user.phone_number"
                  v-validate="'required'"
                  v-mask="'+1##########'"
                  :error-messages="errors.collect('phone_number')"
                  type="phone"
                  label="Phone Number"
                  data-vv-name="phone_number"
                  required
                  />
                <v-checkbox label="Account Admin?" v-model="user.is_account_admin" />
                <v-checkbox label="TOTP Enabled?" v-model="user.totp_mfa_enabled" readonly />
                <v-label>User Status:</v-label>&nbsp;<v-chip>{{ user.user_status }}</v-chip>
                <br/>
                <v-label>Enabled</v-label>&nbsp;<v-chip>{{ user.enabled ? 'true' : 'false'}}</v-chip>
                <br/>
                <v-label>Cognito MFA Options</v-label>&nbsp;<v-chip>{{ JSON.stringify(user.cognito_mfa_options) }}</v-chip>
                <br/>
                <v-label>Cognito Preferred MFA Settings</v-label>&nbsp;<v-chip>{{ user.cognito_preferred_mfa_setting }}</v-chip>
                <br/>
                <v-label>Cognito User MFA Settings List</v-label>&nbsp;<v-chip>{{ user.cognito_user_mfa_setting_list }}</v-chip>
                <br/>
                <v-spacer></v-spacer>
                <div class="mt-8">
                  <v-btn
                    color="primary"
                    type="submit"
                    class="mr-2"
                    @click.prevent="validateAndSubmit"
                  >Save</v-btn>
                  <v-btn :to="{ name: 'users_path' }">Cancel</v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-slide-y-transition>
    </v-col>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { mapFields } from 'vee-validate'

export default {
  name: 'user',
  props: {
    userId: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data: function () {
    return {}
  },

  computed: {
    ...mapState('UserStore', {
      user: 'user'
    }),
    ...mapFields(['name', 'email', 'is_account_admin', 'username']),
    enableDisableUserText: function () {
      return this.user.enabled ? 'Disable User' : 'Enable User'
    },
    titleDesc: function () {
      if (this.userId) {
        return 'Editing [' + this.user.name + ']'
      } else {
        return 'New User'
      }
    }
  },
  mounted: function () {
    if (this.userId) {
      this.$logger.trace('Fetching User ' + this.userId)
      this.$store
        .dispatch('UserStore/getUser', { id: this.userId })
        .catch(error => {
          this.$logger.error('Error loading User', error.message)
          this.$flash({
            showClose: true,
            message: 'Error Loading User. Reload to try again',
            type: 'error'
          })
        })
    } else {
      this.$store.commit('UserStore/resetUser')
    }
  },
  methods: {
    validateAndSubmit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.saveUser()
        }
      })
    },
    saveUser () {
      this.$store
        .dispatch('UserStore/saveUser', this.user)
        .then(response => {
          this.$logger.trace(response)
          this.$router.push({ name: 'users_path' })
          this.$flash({
            showClose: true,
            message: `Saved User ${this.user.name}`,
            type: 'success',
            duration: 2000
          })
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: 'Error Saving User. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    toggleUserEnabled () {
      if (this.user.enabled) {
        this.$store.dispatch('UserStore/disableUser', this.user)
          .then(() => {
            this.$flash({
              showClose: true,
              message: `Disabled User ${this.user.name}`,
              type: 'mini',
              duration: 2000
            })
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error Disabling User. ' + error.message,
              type: 'error',
              duration: 0
            })
          })
      } else {
        this.$store.dispatch('UserStore/enableUser', this.user)
          .then(() => {
            this.$flash({
              showClose: true,
              message: `Disabled User ${this.user.name}`,
              type: 'mini',
              duration: 2000
            })
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error enabling User. ' + error.message,
              type: 'error',
              duration: 0
            })
          })
      }
    }
  }
}
</script>
